/* This file is autogenerated, see readme.md for instructions */
import StringSvgIcon from '@bloomreach/banana-theme/icons/string.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const StringIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <StringSvgIcon />
    </Icon>
  );
});

StringIcon.displayName = 'StringIcon';

export default StringIcon;
